import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { bindActionCreators } from "redux";

import "./MainPage.scss";

import messages from "../../assets/i18n";
import OrderList from "../../containers/OrderList/OrderList";
import havePermissionTo from "../../utils/havePermission";
import { Creators as actionLoad } from '../../store/ducks/load'
import haveOrderPermissionTo from "../../utils/haveOrderPermission";
import { ButtonStandard, FooterActions, ToastMessage, OrderFilter } from '../../components';
import { ALGODAO_BCI, DEMAIS_ATRIBUTOS_SUSTENTAVEIS, MISTO, NATUREZAPEDIDO } from '../../utils/constants';

function MainPage(props) {

	const dispatch = useDispatch();

	const lang = useSelector(state => state.language.name);
	const orderList = useSelector(state => state.orderList);
	const load = useSelector(state => state.load);
	const permissions = useSelector(state => state.authorization.permissions);
	const orderSampleValidationToast = useSelector(state => state.orderSample.orderSampleToast);
	const orderSampleRedirect = useSelector(state => state.orderSample.orderSampleRedirect);
    const isLoadingReport = useSelector(state => state.relatorio.isLoadingReport);

	const [errorMessage, setErrorMessage] = useState('');
	const [show, setShow] = useState(false);
	const [messageType,  setMessageType]  = useState('toast-success');

	const getReport = (pedido, enterpriseName) => {
		dispatch({
			type: "GET_REPORT",
			payload: {
				pedido: pedido,
				enterpriseName: enterpriseName
			}
		})
	};
	const setLoad = (pedidos) => {
		dispatch({
			type: "SET_LOAD",
			payload: pedidos
		})
	};
	const clearLoadError = bindActionCreators(actionLoad.clearLoadError, dispatch);

	useEffect(() => {
		if (load.loadId !== null && load.loadIdLoading === false) {
			loadDetails();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [load])

	useEffect(() => {	
		let toast = orderSampleValidationToast
		let order = orderList[0]

        setShow(toast.showToast)
        setErrorMessage(toast.message)
        setMessageType(toast.messageType)

		if (!toast.showToast && toast.messageType === 'toast-success' && order && orderSampleRedirect) {
			dispatch({
				type: "SET_ORDER_SAMPLE_REDIRECT",
				payload:  {
					redirect: false,
					showToast: false,
					message: '',
					messageType: "toast-success"
			}})

			if (order.utilizaSubContratado) {
				props.history.push(`/subcontractor-invoice`);
			} else {
				if((order.sustentabilidade === ALGODAO_BCI || order.sustentabilidade === DEMAIS_ATRIBUTOS_SUSTENTAVEIS || order.sustentabilidade === MISTO) && 
				   (order.empresa.exigirCertSustentabilidade) &&
				   (order.naturezaPedido === NATUREZAPEDIDO.NORMAL || order.naturezaPedido === NATUREZAPEDIDO.IMPORTADO)) {
					props.history.push(`/sustainability`);
				}else {
					if (order.fornecedor.exigirDeclProdutor && order.empresa.exigirDeclProdutor && order.naturezaPedido === NATUREZAPEDIDO.NORMAL) {
						props.history.push('/producer-declaration');
					} else {
						props.history.push('/reconcile');
					}
				}
			}
		}
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [orderSampleValidationToast]);

	const getErrorsMessage = (message) => {
		setErrorMessage(message);
		setShow(true);
		return false;
	};

	const loadMount = () => {
		setErrorMessage('');
		clearLoadError();

		// Testa se os pedidos selecionadas estão na mesma semana comercial de entrega
		// estão na mesma semana, são do mesmo fornecedor ou já tem carga.
		let sameDeliverWeek;
		let sameCD;
		let sameProvider;
		let message = '';

		if (!haveOrderPermissionTo('load', orderList)) {
			message = messages[lang].messageErrorLoadMount.errorStatus;
			return getErrorsMessage(message);
		}

		orderList.forEach(order => {

			if (!sameDeliverWeek) {
				sameDeliverWeek = order.calendarioComercial.semanaComercial;
			} else if (sameDeliverWeek !== order.calendarioComercial.semanaComercial) {
				message = messages[lang].messageErrorLoadMount.errorDeliverWeek;
				return getErrorsMessage(message);
			}

			if (!sameCD) {
				sameCD = order.localizacaoFisica.id;
			} else if (sameCD !== order.localizacaoFisica.id) {
				message = messages[lang].messageErrorLoadMount.errorDistributionCenter;
				return getErrorsMessage(message);
			}

			if (order.carga) {
				message = messages[lang].messageErrorLoadMount.errorExistingOrder;
				return getErrorsMessage(message);
			}

			if (!sameProvider) {
				sameProvider = order.fornecedor.id;
			} else if (sameProvider !== order.fornecedor.id) {
				message = messages[lang].messageErrorLoadMount.errorProvider;
				return getErrorsMessage(message);
			}

		});

		if (message.length === 0) {
			setLoad(orderList);
		};
	};

	const loadDetails = () => {
		props.history.push(`/load-details`);
	};

	const reconcile = () => {
		let order = orderList[0];
	
		dispatch({
			type: "VALIDATE_ORDER_SAMPLE",
			payload: {
				idPedido: order.id,
			}
		})
	};

	const boxTag = () => {
		props.history.push(`/box-tag`);
	}

	const priceTag = () => {
		props.history.push(`/price-tag`);
	}

	const importChart = () => {
		props.history.push(`/import-chart`);
	}

	const selectOneOrder = (orderList, typeAction) => {
		if (orderList.length === 1) {
			if (typeAction === "reconcile") {
				if (orderList[0].conciliacaos.length > 0) {
					if (orderList[0].conciliacaos[0].statusConciliacaoComercial.id === "2" &&
						(orderList[0].conciliacaos[0].statusConciliacaoFiscal.id === "2" || orderList[0].conciliacaos[0].statusConciliacaoFiscal.id === "6")) {
							return true
					}
				}
			}

			if (typeAction === "btn-po-report" && orderList[0].status === "W") {
				if (havePermissionTo("btn-po-report-admin", permissions)) {
					return false
				}
			}
			
			if (typeAction === "box-tag" && orderList[0].status === "D") {
				if (havePermissionTo("box-tag-admin-print", permissions)) {
					return !haveOrderPermissionTo(typeAction, orderList)
				} else {
					return true
				}				 
			} else {
				return !haveOrderPermissionTo(typeAction, orderList);
			}
		} else {
			return true;
		}
	}

	const setShowFunc = (visible) => {
		setShow(visible ? visible : false);
	}

	const titlePage = messages[lang].ordersInquiry;

	const hasPrePoSelected = orderList && orderList.some(order => order.prePo === 'Y');

	const ButtonGroupLeft = () => {
		return <>
			{havePermissionTo("box-tag", permissions) ? (
				<ButtonStandard
					id="order_list_boxlabel_button"
					disabled={hasPrePoSelected || selectOneOrder(orderList, "box-tag")}
					text={messages[lang].boxLabel}
					textClass="text-3"
					className="btn btn-primary px-2 py-2 btn-light"
					icon="icon-export text-3"
					onClick={boxTag}
				/>
			) : null}

			{havePermissionTo("price-tag", permissions) ? (
				<ButtonStandard
					id="order_list_tag_button"
					disabled={hasPrePoSelected || selectOneOrder(orderList, "price-tag")}
					text={messages[lang].tag}
					textClass="text-3"
					className="btn btn-primary px-2 py-2 btn-light"
					icon="icon-export text-3"
					onClick={priceTag}
				/>
			) : null}

			{havePermissionTo("reconcile", permissions) ? (
				<ButtonStandard
					id="order_list_reconcile_button"
					disabled={hasPrePoSelected || selectOneOrder(orderList, "reconcile")}
					text={messages[lang].reconcile}
					textClass="text-3"
					className="btn btn-primary px-2 py-2 btn-light"
					icon="icon-box text-3"
					onClick={reconcile}
				/>
			) : null}

		</>
	}

	const ButtonGroupRight = () => {
		return <>

			{havePermissionTo("load", permissions) ? (
				<ButtonStandard
					id="order_list_assemble_cargo_button"
					disabled={orderList.length <= 0}
					text={messages[lang].loadCargo}
					textClass="text-3"
					className="btn btn-primary px-2 py-2 btn-light"
					icon="icon-box text-3"
					onClick={loadMount}
				/>
			) : null}

			{havePermissionTo("btn-po-report", permissions) ? (
				<ButtonStandard
					id="order_list_export_button"
					disabled={selectOneOrder(orderList, "btn-po-report")}
					text={messages[lang].export}
					textClass="text-3"
					className="btn btn-primary px-2 py-2 btn-light"
					icon="icon-export text-3"
					isLoading={isLoadingReport}
					onClick={() => getReport(orderList[0].id, orderList[0].empresa.nome)}
				/>
			) : null}

			{havePermissionTo("import-chart", permissions) ? (
				<ButtonStandard
					id="import-chart_button"
					disabled={selectOneOrder(orderList, "import-chart")}
					text={messages[lang].importChart}
					textClass="text-3"
					className="btn btn-primary px-2 py-2 btn-light"
					icon="icon-export text-3"
					onClick={importChart}
				/>
			) : null}
		</>
	}
	
	return (
		<div className="mainPage">
			<ToastMessage 
				show={show}
				setShow={setShowFunc}
				message={errorMessage}
				toastClass={messageType} 
				delay={300000}/>
			<Container className="pt-3 justify-content-start">
				<Row className="justify-content-between">
					<Col className="d-flex align-items-center justify-content-start">
						<span className="text-3 font-weight-bold header-main pl-2">{titlePage}</span>
					</Col>
				</Row>
				<OrderFilter />
			</Container>

			<OrderList />

			<FooterActions ButtonGroupLeft={ButtonGroupLeft} ButtonGroupRight={ButtonGroupRight} />
		</div>
	);
};


export default withRouter(MainPage);

			